import React, {useEffect, useRef} from 'react';
import {InitializeController} from "./initialize-controller";
import {observer} from "mobx-react";

export const BaseComposer = (settings) => (Widget) => InitializeController(settings)(observer((props) => {
    const loaded = useRef(false);
    const status = useRef("pending");
    const result = useRef(undefined);

    useEffect(() => {
        try {
            useOnLoad(props.controller, status, result);
            result.current?.();
            loaded.current = true;
        } catch (e) {
            console.log(e);
        }
    }, []);

    useEffect(() => {
        return () => {
            props.controller.onUnload();
        }
    }, []);


    useEffect(() => {
        if (loaded.current) {
            props.controller.onDidUpdate(props, props.controller.props);
        }
    }, [props]);

    return <Widget {...props} />
}));

function useOnLoad(controller, status, result) {
    let fetching = controller.onLoad()
        // Fetch request has gone well
        .then((success) => {
            status.current = "fulfilled";

            result.current = success;
        })
        // Fetch request has failed
        .catch((error) => {
            status.current = "rejected";

            result.current = error;
        });

    return () => {
        if (status.current === "pending") {
            throw fetching; // Suspend(A way to tell React data is still fetching)
        } else if (status.current === "rejected") {
            throw result; // Result is an error
        } else if (status.current === "fulfilled") {
            return result; // Result is a fulfilled promise
        }
    };
}

